var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCitybackground5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2_00000105406100336102381560000011728745840096301758_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1233 1305.6",
    style: {
      enableBackground: "new 0 0 1233 1305.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#CCCCCC;stroke-miterlimit:10;}\r\n\t.st1{fill:#CCCCCC;}\r\n\t.st2{fill:#EDEDED;}\r\n\t.st3{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "1319.3,555 1140.6,512.5 1136.2,499.3 952.9,354.7 952.9,555 952.9,555 952.9,1312.7 1319.3,1312.7  1319.3,643.9 1319.3,643.9 1319.3,643.9 1319.3,555  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "649.4,184.9 638.4,184.9 638.4,250.8 558.5,250.8 558.5,1312.7 924.9,1312.7 924.9,250.8  649.4,250.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M493.6,547.8H370.8v-26l3.8-0.7l0.7,0.2l0.1-0.4l35.1-6.8l-0.5-1.6l-35.4,6.9l-3.6-0.9l26.6-5.2l-0.5-1.6 l-29.9,5.8l-4.3-1.1l17.9-3.5l-0.5-1.6l-59.1,11.5l0.5,1.6l37.9-7.4l-0.1,0.2l3.9,1l-25.3,4.9l0.5,1.6l28.3-5.5v1.6L351,524 l0.5,1.6l15.3-3v25.3h-32v85H212.1v260.5h-51.9v-112h-19v-54.7l7.7-1.4l-1.7-5.8l-17,3.2h0l-61.3,11.5l1.7,5.8l8.6-1.6v43.1H-50.5 v112h-51.9v414.6h639V632.8h-42.9L493.6,547.8L493.6,547.8z M130.2,781.4H90.3v-45.2l39.9-7.5V781.4z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 665.6,
    y: 417.8,
    className: "st1",
    width: 22.9,
    height: 18
  }), /*#__PURE__*/React.createElement("rect", {
    x: 823.9,
    y: 350.5,
    className: "st1",
    width: 22.9,
    height: 18
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1298.9,646.5h-36.3v-38h-12.1v38h-62.8v-23.1h-125.3v23.1h-45c-11.3,0-20.4,7.6-20.4,16.9v418 c-3.7-0.6-7.5-0.9-11.4-0.9h-47v-17.9h-11.4v17.9h-46.7c-12.9,0-25,3.3-34.9,8.9V790.2c0-8.4-8.2-15.2-18.3-15.2h-26.9V662.1 c0-4.2-4.1-7.6-9.2-7.6H744v-21.6c0-3-2.9-5.4-6.5-5.4h-47v-65h-12.1v65h-42.7c-3.6,0-6.5,2.4-6.5,5.4v21.6h-49.1 c-5.1,0-9.2,3.4-9.2,7.6V775h-29.4c-10.1,0-18.3,6.8-18.3,15.2v171.3h-41.4c-62.3,0-117.3,26.1-149.9,65.7V883.5l0,0v-39l-36.2,6 v-33h-51.9v41.6l-56.7,9.4v-11h-25.3v15.2l-59.1,9.8l6,1h-6v238H87.5v-35.7H76.1v35.7H60.5v-90.4c0-14-7.4-26.5-19.2-35.1v-11.7 H-8.3v-10.9h-25.3v10.9h-50.4v12.3c-11.3,8.5-18.4,20.8-18.4,34.4v280.4h627.6v-1H537c1.5,0.3,3,0.5,4.6,0.5h282.7 c1,0.3,2.1,0.5,3.3,0.5h210.9c1.7,0,3.2-0.4,4.5-1h255.8c11.3,0,20.4-7.6,20.4-16.9V663.4C1319.2,654.1,1310.1,646.5,1298.9,646.5 L1298.9,646.5z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1072.1,
    y: 719.8,
    className: "st3",
    width: 22.9,
    height: 18
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCitybackground5);
export default __webpack_public_path__ + "static/media/citybackground5.f40bb78cc1afea5849b1e7840fbbcd91.svg";
export { ForwardRef as ReactComponent };